import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Domain } from "../../../../../builder/models/domain.model";
import { SummaryFlowViewComponent } from '../../summary-flow-view/summary-flow-view.component';
import { DefaultDisplayComponent } from "../default-display/default-display.component";

@Component({
    selector: 'domain-driven-display',
    templateUrl: './domain-driven-display.component.html',
    styleUrls: ['./domain-driven-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DomainDrivenDisplayComponent extends DefaultDisplayComponent implements OnInit {

    get displayValue(): string {
        let list = this.domains.get(this.question.questionDomain);
        if (list) {
            const domain = list.find(d => d.Code === this.value);
            if (domain != null) {
                return domain.Definition;
            }
        }
        return this.value;
    }

    @Input() domains: Map<string, Domain[]> = new Map<string, Domain[]>();

    constructor() { super(); }

    ngOnInit() {
        super.ngOnInit();
    }

}
